<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
            </div>
        </section>
        <section class="section-skew" style="margin-top: 30px" v-if="profile != null">
            <div class="container mt--100">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 order-lg-2">
                                <div class="card-profile-image align-center justify-center ml-auto mr-auto">
                                    <img v-if="profile.user_avatar == null || profile.user_avatar.length == 0"
                                         :src="require('@/assets/image/user_avatar.png')"
                                         class="card-profile-image rounded-circle center_cropped">
                                    <img v-else :src="profile.user_avatar"
                                         class="card-profile-image rounded-circle center_cropped">
                                </div>
                                <label v-ripple for="uploaduser" class="fa fa-plus-circle display-1 pick-image"></label>
                            </div>
                            <base-button tag="span"
                                         style="position: absolute; top: 0; right: 0"
                                         @click="showExit"
                                         class="m-3"
                                         type="danger"
                                         icon="fa fa-sign-out">
                                {{language.lang("Log out")}}
                            </base-button>
                            <base-button tag="span"
                                         :style="'position: absolute; top: 0; left: 0;'"
                                         @click="$router.push('/form')"
                                         class="m-3"
                                         type="default"
                                         icon="ni ni-curved-next">
                                {{language.lang("Get Started")}}
                            </base-button>
                        </div>
                        <div class="text-center" style="margin-top: -20px">
                            <h3 class="mr-auto ml-auto text-center font-weight-bold">{{profile.username}}</h3>
                            <h6 class="mr-auto ml-auto text-center">{{profile.email != null ? profile.email : "+98" + profile.phone.substring(1)}}</h6>
                        </div>
                        <div class="mt-5">
                            <input type="file"
                                   accept="image/*"
                                   @change="onFileChange"
                                   id="uploaduser"/>
                            <div style="text-align: center">
                            </div>
                            <div>
                                <v-tabs grow align-with-title :show-arrows="false"
                                        v-model="tabs" color="gray" style="font-size: 11px; font-weight: bold">
                                    <v-tab
                                            style="font-size: 11px; font-weight: bold"
                                            v-for="n in items"
                                            :key="n">
                                        {{ n }}
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items style="min-height: 500px" class="mt-3"  v-model="tabs">
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Client></Client>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Edit></Edit>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Visit></Visit>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Share></Share>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Message></Message>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import Edit from "./Edit";
    import Share from "./Share";
    import Message from "./Message";
    import language from "@/utils/language";
    import Client from "@/views/lawyer/Client";
    import Visit from "@/views/lawyer/Visit";

    export default {
        components: {
            Visit,
            Client,
            Edit,
            Share,
            Message,
        },
        data() {
            return {
                profile: null,
                language: language,
                oracle: oracle,
                tabs: null,
                isEN: oracle.isEN(),
                items: [
                    language.lang('Cases'),
                    language.lang('Profile'),
                    language.lang('Consultants'),
                    language.lang('Share'),
                    language.lang('Inbox'),
                ],
            }
        },
        methods: {
            showExit() {
                oracle.showMessage(language.lang('Are you sure to exit?'), language.lang('Yes, Log me out'), () => {
                    oracle.logOut()
                    this.$router.push('/')
                })
            },
            onFileChange(e) {
                let file = e.target.files[0];
                oracle.axiosUpload(file, (response) => {
                    let model = {user_avatar: response.data};
                    oracle.axios("user/edit", model, (res) => {
                        this.profile.user_avatar = response.data
                    });
                });
            },
        },
        mounted() {
            oracle.axios("user/getProfile", null, (response) => {
                this.profile = response.data;
            });
        }
    };
</script>
<style>
    .uploadAvatar {
        position: absolute;
        right: 2px;
        bottom: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25px;
        background: #fff;
    }

    .uploadAvatar .v-icon {
        font-size: 30px !important;
        color: #42C7D5 !important;
    }

    input[type="file"] {
        display: none;
    }

    .contentProfile {
        max-height: 55%;
        margin-bottom: 20px;
    }

    .itemsProfile {
        margin-top: 20px;
        max-height: 65vh;
        overflow: auto;
        margin-bottom: 1em;
    }

    .itemProfile a,
    .itemExit {
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        color: #000;
        font-size: 12px;
    }

    .itemProfile a .v-icon,
    .itemExit .v-icon {
        color: #000;
        font-size: 15px;
    }

    .pick-image {
        position: absolute;
        right: 100px;
        bottom: 85px;
        color: #427BD5;
        text-align: center;
        align-self: center;
        align-items: center;
        justify-items: center;
        justify-self: center;
        line-height: 0 !important;
    }

    .pick-image::before {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        background: white;
        line-height: 0;
    }

    .message-empty-profile {
        margin-top: 50px;
        margin-bottom: 50px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .message-empty-profile .v-icon {
        font-size: 4.5em;
    }

    .message-empty-profile p {
        font-size: 13px;
    }
</style>
